import { OrderCheckout } from './OrderCheckout';
import { OrderSummary } from './OrderSummary';
import { ShirtLogo } from './ShirtLogo';

const Shop = {
  run() {
    let checkoutForm = document.getElementById('checkoutForm');
    let orderSummary = document.getElementById('orderSummary');

    if (checkoutForm && orderSummary) {
      this.orderCheckout = new OrderCheckout(checkoutForm);
      this.orderSummary = new OrderSummary(checkoutForm, orderSummary, orderSummary.dataset.route);
      this.shirtLogo = new ShirtLogo(checkoutForm, this.orderSummary);
    }
  }
};

Shop.run();
